import { getField, updateField } from 'vuex-map-fields'

// const MODULE_NAME = "cashTransfer";

/* Define Action Name */

/* Define Getter Name */

/* Define Mutation Name */

/* Define Export Name */

const state = {
  form: {
    bankName: '',
    bankType: '',
    bankAccountNumber: '',
    bankAccountName: '',
    idNumber: '', // either IC or Passport
    emailAddress: ''
  }
}

const getters = {
  getField
}

const actions = {}

const mutations = {
  updateField
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
